import {
  prefetchCustomerCompanyRetrieveQuery,
  prefetchCustomerRepositoryListQuery,
  useCustomerCompanyRetrieveSuspense,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { DownloadIcon } from "lucide-react"

import { BusinessDocumentsCard } from "@/components/documents/BusinessDocumentsCard"
import { CategorizedDocumentsCard } from "@/components/documents/CategorizedDocumentsCard"
import { CustomerDocumentProvider } from "@/components/documents/context/DocumentsProvider"
import { DownloadButton } from "@/components/documents/DownloadButton"
import { RequestedDocumentsCard } from "@/components/documents/RequestedDocumentsCard"
import { SignBoundlessApplicationCard } from "@/components/documents/SignBoundlessApplicationCard"
import { UncategorizedDocumentsCard } from "@/components/documents/UncategorizedDocumentsCard"
import { UploadDocumentCard } from "@/components/documents/UploadDocumentCard"
import { buttonVariants } from "@/components/ui/button"

export const Route = createFileRoute("/_dashboard/documents")({
  component: DocumentsView,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (!hasPermissions(["repository.view_repositorydocument"])) {
      throw redirect({ to: "/" })
    }
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/home" })
    }
    return { companyUuid }
  },
  loader: ({ context: { queryClient, companyUuid } }) => {
    prefetchCustomerRepositoryListQuery(queryClient, companyUuid)
    prefetchCustomerCompanyRetrieveQuery(queryClient, companyUuid)
  },
})

function DocumentsView() {
  const { companyUuid } = Route.useRouteContext()

  const { data: company } = useCustomerCompanyRetrieveSuspense(companyUuid)

  return (
    <CustomerDocumentProvider companyUuid={companyUuid}>
      <div className="flex flex-row gap-5">
        <div className="flex w-full flex-col gap-5">
          <div className="flex flex-row items-center justify-between">
            <h1 className="text-lg font-bold">{company.legalName} Documents</h1>
            <DownloadButton
              filename={`${company.legalName}-documents.zip`}
              url={`/api/customer/repository/${companyUuid}/export/`}
              className={buttonVariants()}
            >
              <DownloadIcon />
              Export
            </DownloadButton>
          </div>
          <UploadDocumentCard companyUuid={companyUuid} />
          <SignBoundlessApplicationCard companyUuid={companyUuid} />
          <UncategorizedDocumentsCard />
          <BusinessDocumentsCard />
          <CategorizedDocumentsCard />
        </div>
        <RequestedDocumentsCard
          companyUuid={companyUuid}
          className="min-w-sm"
        />
      </div>
    </CustomerDocumentProvider>
  )
}
